
import React, { useState, useEffect, useRef} from "react";
import app from "../../../firebaseConfig";
import { getDatabase, ref, get } from "firebase/database";
import { motion } from "framer-motion"; // Importamos framer-motion
import { useNavigate,useSearchParams } from "react-router-dom"; // Importamos useNavigate

import Lottie from "react-lottie-player";
import rayoazul from './assets/lottie/rayoazul.json';
import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import CarruselImagenes from "./3dfyrioncarruselimgssimulador";
import BannerRotativo from "./3dfyrionbannerrotativo"; //
import Testimonios from "./3dfyriontestimonios"; //

import { FaBars, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";


  export default function AwooEntradass({ setView, navigate }) {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito

  const [searchParams] = useSearchParams();
  const mesa = searchParams.get("mesa"); // Obtiene el número de la mesa

  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);

const [mostrarBotonArriba, setMostrarBotonArriba] = useState(false);

const isMobile = typeof window !== "undefined" && window.innerWidth <= 480;
const [menuAbierto, setMenuAbierto] = useState(false);



  const [productos, setProductos] = useState([]);

  const toggleBusqueda = () => {
    setMostrarBusqueda(!mostrarBusqueda);
  };

  //////////////// Por si se ve en CEL LOGICA DE REDIMENSION
  const [esMovil, setEsMovil] = useState(false);

  const categoryRefs = useRef({});
  const categoriasRef = useRef(null);

  const [activeCategory, setActiveCategory] = useState(null);


      

  useEffect(() => {
    const manejarResize = () => {
      setEsMovil(window.innerWidth < 600); // ← Define punto de quiebre para "pantallas pequeñas"
    };

    manejarResize(); // Ejecutar en el primer render
    window.addEventListener("resize", manejarResize);
    return () => window.removeEventListener("resize", manejarResize);
  }, []);
  /////////////


  // Arreglo de animaciones disponibles
  const animacionesDisponibles = [
    lineasblancasvolando,
    efectoparticulas,
    fuegoamarillo,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    neutron,
    ondacircular,
    ondacircular,
    ondacircular,
    fuegoamarillo,
  ];
  

  //---------------------------------------------------------------------------------
  const tiempoMaximoCache = 1000 * 60 * 30; // 30 minutos
  




// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};

     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);


  ////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
////////////////////////






///////////////////
//Codigo para barra deslizante infinita
const mensajes = [
    "🚚 Envíos a toda Colombia",
    "⏳ ¡Tiempo limitado!",
    "🎉 Después de 5 Unidades Descuento 30%",
    "💎 Exclusivo en nuestra tienda",
    "🎯 Ideal para regalar",
    "🎈 ¡Aprovecha antes que se agote!"
  ];

  // Repetimos los mensajes para dar continuidad
  const contenido = [...mensajes, ...mensajes];
///////////////



  
  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };


  

    return (
        <div style={{ display: "flex",overflowX: "hidden" , width: "100%", boxSizing: "border-box", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#000", color: "white", textAlign: "center"}}>    

{/* ------------------ BARRA LATERAL ------------------------ */}
<motion.div
  initial={{ x: "-100%" }}
  animate={{ x: menuAbierto ? 0 : "-100%" }}
  transition={{ duration: 0.3, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    zIndex: 9999,
    padding: "20px",
    boxShadow: "4px 0 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  }}
>
  {/* Botón cerrar */}
  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      onClick={() => setMenuAbierto(false)}
      style={{
        background: "none",
        border: "none",
        color: "white",
        fontSize: "26px",
        cursor: "pointer",
      }}
    >
      ✖
    </button>
  </div>

  {/* Opciones principales */}
  <div style={{ marginTop: "10px", marginBottom: "20px" }}>
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
      <div
        key={opcion}
        onClick={() => {
          if (opcion === "INICIO") navigate("/");
          if (opcion === "PRODUCTOS") navigate("/3dfyrioninicioproductos");
          if (opcion === "SIMULADORES") navigate("/3dfyrioninicionosotros");
          setMenuAbierto(false);
        }}
        style={{
          padding: "12px 0",
          paddingLeft: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: "pointer",
          borderBottom: "1px solid #333",
        }}
      >
        {opcion}
      </div>
    ))}
  </div>

</motion.div>

{/* Fondo oscuro cuando menú está abierto */}
{menuAbierto && (
  <div
    onClick={() => setMenuAbierto(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9998,
    }}
  ></div>
)}
{/* ---------------------------------------------------------- */}



  {/* Encabezado */}
  <div
      style={{
        width: "100%",
        height: "70px",
        backgroundColor: "#111",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Lado izquierdo - botón de menú y logo + lupa */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginLeft: "15px",
        }}
      >
        
      {/* <FaBars size={35} style={{ cursor: "pointer" }} /> */}
      <FaBars 
  size={35} 
  style={{ cursor: "pointer" }} 
  onClick={() => setMenuAbierto(true)}
/>

        
        <img
          src="images/dragonfondo2.png"
          alt="Logo"
          style={{
            height: "75px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        <FaSearch
          size={20}
          style={{ cursor: "pointer" }}
          onClick={toggleBusqueda}
        />
      </div>

      {/* Centro - barra de búsqueda */}
      {mostrarBusqueda && (
        <input
          type="text"
          placeholder="Buscar..."
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50%",
            height: "35px",
            borderRadius: "8px",
            padding: "0 15px",
            border: "none",
            outline: "none",
            fontSize: "16px",
          }}
        />
      )}

      {/* Lado derecho - carrito + contador + perfil */}
{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      position: "relative",
      width: "48px",
      cursor: "pointer",
      marginRight:"19px"
    }}
  >
    <div
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        border: "3px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "45%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 5px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}
    </div>

    {/* BARRA DE NAVEGACIÓN */}
<div
  style={{
    width: "100%",
    backgroundColor: "#111",
    display: "flex",
    justifyContent: "center",
    padding: "10px 0",
    boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
    position: "sticky", // opcional: se queda arriba
    top: 0,
    zIndex: 999,
  }}
>
  <div
    style={{
      width: "95%",
      maxWidth: "1200px",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: "20px",
      flexWrap: "wrap", // para que sea responsive
    }}
  >
    
    
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
  <button
    key={opcion}
    onClick={() => {
        if (opcion === "INICIO") setView("INICIO");
        if (opcion === "PRODUCTOS") setView("PRODUCTOS");
        if (opcion === "SIMULADORES") setView("SIMULADORES");
    }}
    style={{
      background: opcion === "SIMULADORES" ? "white" : "none",
      color: opcion === "SIMULADORES" ? "black" : "white",
      border: "none",
      fontWeight: "bold",
      fontSize: "11px",
      cursor: "pointer",
      padding: "12px",
      borderRadius: "6px",
    }}
  >
    {opcion}
  </button>
))}


  </div>
</div>

  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"2px"
      }}
    >
    </div>




  {/* Barra Deslizante */}
  <div
      style={{
        width: "100%",
        height: "35px",
        backgroundColor: "#222",
        color: "#fff",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      <div
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
          animation: "mover 8s linear infinite",
        }}
      >
        {contenido.map((texto, index) => (
          <span key={index} style={{ marginRight: "60px" }}>
            {texto}
          </span>
        ))}
      </div>

      {/* Animación CSS */}
      <style>
        {`
          @keyframes mover {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>

  {/* Animación de fondo */}
   <div
  style={{
    marginLeft: "15px",
    position: "relative",
    flexShrink: 0, // Evita que las tarjetas se reduzcan
  }}
>

 {/* Animación de fondo */}
 <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        justifyContent: "center",
        width: '700px',
        height: '700px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />


   </div>



{/* CONTENIDO QUE SE OCULTA HASTA QUE LA CARGA TERMINE */}
<div style={{  width:"100%"}}>


<CarruselImagenes
  imagenes={[
    "https://fbi.cults3d.com/uploaders/26541637/illustration-file/8c0a0e7f-bbca-4376-984a-1700a76e973b/Photoroom_20240313_100211.jpg",
    "https://images.cults3d.com/2TZ6CPzPULNIIgHpl4_W36KVFI8=/516x516/filters:no_upscale()/https://fbi.cults3d.com/uploaders/17282128/illustration-file/ae3bdd37-b689-407d-bda6-7a97c95354d5/LED_-_JAVIER_2024-Sep-15_04-11-47PM-000_CustomizedView162674322.jpg",
    "https://images.cults3d.com/WmJYdGxPoevBv8x0QZybCpNufvA=/516x516/filters:no_upscale()/https://fbi.cults3d.com/uploaders/17282128/illustration-file/a88fcf56-ee75-4d56-97db-d69c47473e77/LED_-_PAULA_2021-Jun-26_07-24-01PM-000_CustomizedView18733400738.jpg",
  ]}
  titulo="Lámpara Personalizada"
  descripcion="Escribe tu nombre y crea tu propia versión de lámpara con tu estilo y tu esencia."
/>

<CarruselImagenes
  imagenes={[
    "https://ruta.com/imagen1.jpg",
    "https://ruta.com/imagen2.jpg",
    "https://ruta.com/imagen3.jpg"
  ]}
/>

<CarruselImagenes
  imagenes={[
    "https://ruta.com/imagen1.jpg",
    "https://ruta.com/imagen2.jpg",
    "https://ruta.com/imagen3.jpg"
  ]}
/>




  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"9px",
         width:"100%"
      }}
    >
    </div>






{/* Nombre de usuario */}
<div
  style={{
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#fff",
    marginBottom: "15px",
    marginTop:"8px"
  }}
>
  @3dfyrion
</div>

{/* Footer */}
<div
  style={{
    width: "100%",
    padding: "15px 0",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
    borderTop: "1px solid #ccc",
  }}
>
  <span style={{ fontSize: "16px", marginRight: "5px" }}>©</span>
  2025, 3dFyrion Colombia | Tecnología y Diseño de 3dfyrion
</div>


{mostrarBotonArriba && (
  <button
    onClick={() => {
      categoriasRef.current?.scrollIntoView({ behavior: "smooth" });
    }}
    style={{
      position: "fixed",
      bottom: "25px",
      right: "25px",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "#017bff",
      color: "white",
      border: "none",
      fontSize: "30px",
      cursor: "pointer",
      boxShadow: "0px 4px 15px rgba(0,0,0,0.4)",
      zIndex: 9999,
    }}
  >
    ↑
  </button>
)}



</div> {/* FIN DEL CONTENIDO OCULTO */}





</div>
    );
}

const botonEstilo = {
    width: "100%",
    padding: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    background: "#e27f0e",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
};
